import { createContext } from 'react';

import { useLocation } from 'shared/hooks';
import { useCountries } from 'shared/hooks/useCountries';

export const GlobalPricingContext = createContext(null);

export const GlobalPricingProvider = ({ children }) => {
  const { selectedCountryCode } = useLocation();
  const countries = useCountries();
  const selectedCountry = countries?.find((country) => country?.isoCode === selectedCountryCode);

  return (
    <GlobalPricingContext.Provider value={selectedCountry || {}}>
      {children}
    </GlobalPricingContext.Provider>
  );
};
